import BaseCrudService from '@/services/base-crud-service'
import taskListConfig from '@/config/task-list-config'
import axiosHttp from '@/utilities/axios-http'

class TaskListService extends BaseCrudService {
  indexAssigned = () => {
    return axiosHttp.get(`${this.resourcePath}/assigned`)
  }

  indexDiscussions = discussable_id => {
    return axiosHttp.get(
      `${this.resourcePath}/${discussable_id}/${taskListConfig.API_DISCUSSIONS_PATH}`
    )
  }

  storeDiscussion = (discussable_id, payload) => {
    return axiosHttp.post(
      `${this.resourcePath}/${discussable_id}/${taskListConfig.API_DISCUSSIONS_PATH}`,
      payload
    )
  }

  updateDiscussion = (discussable_id, id, payload) => {
    return axiosHttp.put(
      `${this.resourcePath}/${discussable_id}/${taskListConfig.API_DISCUSSIONS_PATH}/${id}`,
      payload
    )
  }

  deleteDiscussion = (discussable_id, id) => {
    return axiosHttp.delete(
      `${this.resourcePath}/${discussable_id}/${taskListConfig.API_DISCUSSIONS_PATH}/${id}`
    )
  }
}

export default new TaskListService(taskListConfig.API_RESOURCE)
